// Necessary for SSR
const windowExists = typeof window !== 'undefined';

if (windowExists) {
  window.dataLayer = window.dataLayer || [];
}

export const pushEventWithDebug = event => {
  // eslint-disable-next-line no-console
  console.debug('dataLayer', event);
  window.dataLayer.push(event);
};

export default windowExists ? window.dataLayer : [];



// WEBPACK FOOTER //
// ../globals/dataLayer.js